export interface DraftKey {
  visitId: string
  templateId: string
}

function isSafeKeyPart(value: string): boolean {
  return typeof value === 'string' && value.trim().length > 0
}

export function buildDraftId(visitId: string, templateId: string): string {
  if (!isSafeKeyPart(visitId) || !isSafeKeyPart(templateId)) {
    throw new Error('Invalid draft key context')
  }
  return `${encodeURIComponent(visitId)}:${encodeURIComponent(templateId)}`
}

export function parseDraftId(value: unknown): DraftKey | null {
  if (typeof value !== 'string' || !value.includes(':')) return null
  const parts = value.split(':')
  if (parts.length !== 2) return null

  const [rawVisitId, rawTemplateId] = parts
  if (!rawVisitId || !rawTemplateId) return null

  try {
    const visitId = decodeURIComponent(rawVisitId)
    const templateId = decodeURIComponent(rawTemplateId)
    if (!isSafeKeyPart(visitId) || !isSafeKeyPart(templateId)) return null
    return { visitId, templateId }
  } catch {
    return null
  }
}
